import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import styled from 'styled-components';
import { IMediaItem } from 'modules/media/interfaces/api';
import { Text } from 'basic-ui-lib';

import 'swiper/css';
import 'swiper/css/navigation';
import { RenderMedia } from 'basic-ui-lib/components/screen/RenderMedia';

interface MediaPreviewModalProps {
  items: IMediaItem[];
  initialIndex: number;
  onClose: () => void;
  setPreviewIndex: (index: number | null) => void;
}

export const MediaPreviewModal = ({
  items,
  initialIndex,
  onClose,
  setPreviewIndex,
}: MediaPreviewModalProps) => {
  return (
    <Overlay onClick={onClose}>
      <Modal onClick={e => e.stopPropagation()}>
        <SwiperStyled
          modules={[Navigation]}
          initialSlide={initialIndex}
          navigation
          spaceBetween={30}
          onSlideChange={swiper => {
            setPreviewIndex(swiper.activeIndex);
          }}
        >
          {items.map(item => (
            <SwiperSlide key={item.id}>
              <Content>
                {RenderMedia(item, 0, true)}
              </Content>
            </SwiperSlide>
          ))}
        </SwiperStyled>

        <Footer>
          <Text title_h5 medium color='neutral.text.1'>{items[initialIndex]?.name}</Text>
          <Text title_h9 medium color='neutral.text.1'>({items[initialIndex]?.size}MB)</Text>
        </Footer>
      </Modal>
    </Overlay>
  );
};

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.60);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
`;

const Modal = styled.div`
  max-width: 1300px;
  background: transparent;

  img, video {
    object-fit: contain;
    border-radius: 4px;
    height: 446px;
    align-self: stretch;
    aspect-ratio: 792.89/446.00;
  }
`;

const Footer = styled.div`
  margin-top: 16px;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const SwiperStyled = styled(Swiper)`
  .swiper-button-next,
  .swiper-button-prev {
    color: white;
    width: 50px;
    height: 50px;
  }


  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const Content = styled.div`
  height: 446px;
  aspect-ratio: 792.89/446.00;
  position: relative;
`;